import {Component, signal} from '@angular/core';
import {RouterOutlet} from "@angular/router";
import {SidebarComponent} from "./components/sidebar/sidebar.component";
import {FooterComponent} from "./components/footer/footer.component";
import {InlineSVGModule} from "ng-inline-svg-2";

@Component({
  selector: 'crm-layout',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, FooterComponent, InlineSVGModule],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {
  isSidebarOpen = signal(typeof window !== 'undefined' && window.innerWidth > 1024);

  toggleSidebar() {
    this.isSidebarOpen.update(v => !v);
  }
}
